module.exports = __webpack_public_path__ + "static/media/13_l_bust_10.83_80.56.1f73ddff.png";